import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectSpecialistsPage } from '../../../selectors/selectSpecialists';
import { getSpecialists } from '../../../actions/getSpecialists';
import { IGeoResultValue } from '../../../actions/submitForm/types';

export const useRealtorPagination = (geo: IGeoResultValue | undefined) => {
  const dispatch = useDispatch();
  const specialistPage = useSelector(selectSpecialistsPage);

  const page = {
    total: specialistPage?.count || 0,
    limit: specialistPage?.limit || 10,
    offset: specialistPage?.offset || 0,
  };

  const handleOnChangePage = useCallback(
    (pageNumber: number) => {
      if (geo) {
        dispatch(getSpecialists({ geo, pageNumber }));
      }
    },
    [dispatch],
  );

  return { handleOnChangePage, page };
};
